import React, { useState, useEffect, useRef } from 'react';
import { StyleSheet, View, ScrollView, Text, Platform, TouchableOpacity } from 'react-native';
import { useForm, Controller, useWatch } from 'react-hook-form';
import TextField from '../controls/TextBox';
import NumberField from '../controls/NumberField';
import PaperDates from '../controls/datePicker-paperDates';
import ButtonControl from '../controls/Button';
import { bulkUpdatePackageStatus, createItem, packageStatusEmail, updateItem } from '../service/dataOperations';
import { Loader } from '../../../Common/Loader';
import { useAuth } from '../../../../providers/AuthProvider';
import { useClient } from '../../../../providers/ClientProvider';
import NotificationBanner, { NotificationType } from '../controls/NotificationBanner';
import formCustomStyles from './formStyles';
import * as FileSystem from 'expo-file-system';
import * as MediaLibrary from 'expo-media-library';
import DocPicker from '../controls/DocPicker';
import { IconButton, MD3Colors, Portal, Tooltip, Switch } from 'react-native-paper';
import { ConfirmTop } from '../../../Common/ConfirmBoxTop';
import { ConfirmBottom } from '../../../Common/ConfirmBottom';
import ReactDropdownSingleSelect from '../controls/Dropdown-Single';
import ComplianceTable from '../service/monitoringCompliance';
import { useNav } from '../../../../providers/NavProvider';
import AttachmentViewerModal from '../../LogControllers/AttachmentViewerModal';

interface PaperFormProps {
  formMode: string;
  fields: Array<any>;
  selectedRow: Array<any>;
  closeForm: () => void;
  siteId: string;
  logTitle: string;
  updateFormState: () => void;
  ItemCreated: (Item: Array<any>) => void;
}
type ProjectStatusEmailRequest = {
  siteId: string;
  itemId: number;
  status: "Re-Open" | "Submitted";
  triggeredBy: string;
  month?: string | null;
  year?: string | null;
  nextFreezeDate?: string | null; // ISO-8601
};

const ProjectStatusForm: React.FC<PaperFormProps> = React.memo((props) => {

  const [formMode, setFormMode] = useState(props.formMode);
  const [fields, setFields] = useState(props.fields);
  const [loadForm, setLoadForm] = useState<boolean>(false);
  const [itemId, setItemId] = useState(null);
  const [permissions, setpermissions] = useState("read");
  const [docWarning, setDocWarning] = useState<boolean>(null);
  const [warningText, setWarningText] = useState<string>(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileLoad, setFileLoad] = useState<boolean>(false);
  const [fileType, setFileType] = useState<string>();
  const [visible, setVisible] = React.useState(false);
  const [fileApi, setFileApi] = useState(null);
  const [downloadedFileUri, setDownloadedFileUri] = useState(null);
  const [docType, setDocType] = useState(null);
  const [isViewerVisible, setIsViewerVisible] = useState<boolean>(false);
  const [viewerBlob, setViewerBlob] = useState<Blob | null>(null);
  const [viewerFileName, setViewerFileName] = useState<string>("");
  const [viewerLoading, setViewerLoading] = useState<boolean>(false);
  const [mirrorAcrossPortfolio, setMirrorAcrossPortfolio] = useState<boolean>(false);
  const [showMirrorConfirmation, setShowMirrorConfirmation] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { sitesResp } = useNav();
  useEffect(() => {
    if (sitesResp) {
      const matchedSite = findSiteById(sitesResp, props.siteId);
      matchedSite && matchedSite.permissions && setpermissions(JSON.stringify(matchedSite.permissions && matchedSite.permissions).toLowerCase())
    }
  }, [sitesResp]);
  function findSiteById(siteresp: any, siteId: string) {
    if (!siteresp.children || siteresp.children.length === 0) {
      return null; // No children, return null
    }

    for (let child of siteresp.children) {
      if (child.id === siteId) {
        return child; // Found the matching site
      }

      // Recursively search in child nodes
      const foundSite: any = findSiteById(child, siteId);
      if (foundSite) return foundSite;
    }

    return null; // Site not found in any children
  }
  let item: any;
  //let fields = props.fields;
  useEffect(() => {
    let formFields = props.fields;
    if (formMode === 'Edit' || formMode === 'View') {
      item = props.selectedRow[0] && props.selectedRow[0];
      formFields = item && props.fields.map && props.fields.map((field) => {
        const defaultValue = item[field.key] && item[field.key];
        return { ...field, defaultValue };
      });
      const AttachmentColumn = formFields && formFields.find((c) => c.subType === "attachment");
      if (AttachmentColumn && AttachmentColumn.defaultValue) {
        setUploadedFiles(JSON.parse(AttachmentColumn.defaultValue));
      }
      item?.ID && setFileApi(encodeURI(clientAPIURL + "api/sites/" + props.siteId + "/lists/" + props.logTitle + "/items/" + item.ID + "/attachments/"));
      formFields && setFields(formFields);
      setLoadForm(true);
      item?.ID && setItemId(item.ID);
    }
    else if (formMode === 'New') { setLoadForm(true) }
  }, [formMode, props.fields]);
  const { register, setValue, handleSubmit, control, reset, watch, getValues, formState: { errors } } = useForm();



  React.useEffect(() => {
    if (formMode !== "New") return; // only for new form

    fields.forEach((f) => {
      if (f.subType === "choice" && f.options) {
        const optionsArray = f.options.split("#;#").map((o: string) => o.trim());

        if (optionsArray.length === 1) {
          // only one choice, set it as default
          setValue(f.key, optionsArray[0]);
        }
      }
    });
  }, [fields, formMode, setValue]);




  const [toastVisibility, setToastVisibility] = useState<boolean>(false)
  const [toastText, setToastText] = useState<string>("");
  const [toastType, setToastType] = useState<NotificationType>('info');

  const { getAccessToken, userEmail } = useAuth();
  const { clientName, clientAPIURL } = useClient();
  function MonthYear(value: Date) {
    if (value) {
      const date = new Date(value);
      const timezoneOffset = 4 * 60; // UTC +4 timezone offset in minutes
      const adjustedDate = new Date(date.getTime() + timezoneOffset * 60000);
      const month = adjustedDate.toLocaleString('en-US', { month: 'short' });
      const year = adjustedDate.getFullYear();
      return month + "-" + year;
    } else {
      return null;
    }
  }
  const onSubmit = async (d: any) => {
    setIsSubmitting(true);
    setToastText("Submitting...");
    setToastType('submitting');
    setToastVisibility(true);
    const uploadedFilesJson = JSON.stringify(uploadedFiles);
    //const Month = props.selectedRow[0] && props.selectedRow[0]['Month'];
    //const Year = props.selectedRow[0] && props.selectedRow[0]['Year'];
    const data = { ...d, 'Attachments': uploadedFilesJson };

    //setD(JSON.stringify(data));
    let oItem = data;
    const result = Object.keys(data).map((key) => {
      const column = fields.find((c) => c.key === key);
      if (!column) {
        return null;
      }
      const value = data[key];
      const dataType = column.datatype.toLowerCase();
      if (dataType === 'datetimes') {
        delete oItem.key;
        oItem = { ...oItem, key: value };
      }

      //const sanitize = (val: any) =>
      //typeof val === 'string' ? val.replace(/<[^>]*>?/gm, '') : val;

      const formattedValue =
        dataType === 'strings'
          ? value
          : dataType === 'numbers'
            ? Number(value)
            : dataType === 'datetimes'
              ? value
              : null;

      return {
        column_Name: column.key,
        [`${dataType}_Value`]: formattedValue,
        dataype: dataType,
      };
    }).filter((x) => x !== null);

    let response: any;
    const accessToken: any = await getAccessToken();

    if (mirrorAcrossPortfolio) {
      const bulkData = {
        siteId: props.siteId,
        status: d.Status,
        month: d.Month,
        year: d.Year,
        nextFreezeDate: d.NextFreezeDate ? new Date(d.NextFreezeDate).toISOString() : null,
        triggeredBy: userEmail ? userEmail : "",
        data: result
      };

      try {
        response = await bulkUpdatePackageStatus(accessToken, clientAPIURL, bulkData);
        if (response && response.message) {
          setToastText(response.message);
          setToastType('success');
          setToastVisibility(true);

          // Mimic success behavior for mirroring
          setTimeout(() => {
            setIsSubmitting(false);
            props.ItemCreated(oItem); // Signal refresh (mirroring affects many)
          }, 2000);
          return; // Mirror handles its own success path
        }
      } catch (err: any) {
        setIsSubmitting(false);
        console.error("Error in bulk update:", err);
        setToastText("Bulk operation failed.");
        setToastType('error');
        setToastVisibility(true);
        return;
      }
    }
    else if (formMode === 'Edit') {
      try {
        response = await updateItem(props.logTitle, accessToken, clientAPIURL, props.siteId, itemId, result);
      }
      catch (err: any) {
        setIsSubmitting(false);
        if (err.response?.status === 400) {
          console.error("Error updating item:", err);
          setToastText("Operation Failed: " + err.message);
          setToastType('error');
          setToastVisibility(true);
          return;
        } else {
          setToastText("Something went wrong. Please try again.");
          setToastType('error');
          setToastVisibility(true);
        }
      }
    } else {
      try {
        response = await createItem(props.logTitle, accessToken, clientAPIURL, props.siteId, result);
      }
      catch (err: any) {
        if (err.response?.status === 400) {
          setIsSubmitting(false);
          console.error("Error updating item:", err);
          setToastText("Operation Failed: " + err.message);
          setToastType('error');
          setToastVisibility(true);
          return;
        } else {
          setToastText("Something went wrong. Please try again.");
          setToastType('error');
          setToastVisibility(true);
        }
      }
    }

    if (!response) {
      setIsSubmitting(false);
      setToastText("Operation Failed: You are not authorized to perform this action.")
      setToastType('error');
      setToastVisibility(true);
    }
    if (response) {
      if (typeof response === 'number' || response.ok === true) {
        {
          const packageStatusData: ProjectStatusEmailRequest = {
            siteId: props.siteId,
            itemId: itemId ? itemId : response,
            status: d.Status,
            triggeredBy: userEmail ? userEmail : "",
            month: d.Month,
            year: d.Year,
            nextFreezeDate: d.NextFreezeDate ? new Date(d.NextFreezeDate).toISOString() : null,
          };
          const packageEmailStatus = await packageStatusEmail(accessToken, clientAPIURL, packageStatusData);

          setToastText("Your changes are saved.")
          setToastType('success');
          setToastVisibility(true);
          //const dataArray = [data];
          setTimeout(function () {
            setIsSubmitting(false);
            if (formMode === 'Edit') {
              //const createdItem = oItem && {...oItem, "ID": itemId, "key": itemId };
              if (oItem) {
                oItem["ID"] = itemId
                oItem["key"] = itemId
              }
              const createdItem = oItem
              props.ItemCreated(createdItem);
            }
            else {
              const createdItem = oItem //&& { ...oItem, "ID": response, "key": response };
              if (oItem) {
                oItem["ID"] = response
                oItem["key"] = response
              }
              props.ItemCreated(createdItem);
            }
          }, 2000)
        }
      }
      else if (response && response.ok === false) {
        setIsSubmitting(false);
        setToastText("Operation Failed: One or more inputs contain invalid content.")
        setToastVisibility(true);
        return result
      }
    }
  };

  const onError = (errors: any) => {
    const firstErrorKey = Object.keys(errors)[0];
    const errorField = fields.find(f => f.key === firstErrorKey);
    setToastText(`Please fill in the required field: ${errorField?.title || firstErrorKey}`);
    setToastType('error');
    setToastVisibility(true);
    if (Platform.OS === 'web') {
      const errorElement = document.getElementById(`field-${firstErrorKey}`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  const invalidNumber = () => {
    setToastText("Invaid Entry: Please enter valid number to numerical column.")
    setToastVisibility(true);
  }

  const handleClose = () => {
    props.closeForm()
  }

  const handleReOpen = () => {
    setValue('Status', 'Re-Open');
    if (mirrorAcrossPortfolio) {
      setShowMirrorConfirmation(true);
    } else {
      handleSubmit(onSubmit, onError)();
    }
  };
  const handleReSubmit = () => {
    setValue('Status', 'Submitted');
    if (mirrorAcrossPortfolio) {
      setShowMirrorConfirmation(true);
    } else {
      handleSubmit(onSubmit, onError)();
    }
  };
  const handleReview = () => {
    setValue('Status', 'Reviewed');
    if (mirrorAcrossPortfolio) {
      setShowMirrorConfirmation(true);
    } else {
      handleSubmit(onSubmit, onError)();
    }
  };

  const onConfirmMirror = () => {
    setShowMirrorConfirmation(false);
    handleSubmit(onSubmit, onError)();
  };

  const handleToastDismiss = () => {
    setToastVisibility(false);
  };

  const onFileUploaded = (fileObj: any) => {
    let parsedFileData = JSON.parse(fileObj);
    setUploadedFiles(prevFiles => [...prevFiles, parsedFileData]);
  }

  const showModal = () => setVisible(true);
  const hideModal = () => setVisible(false);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [fileId, setFileId] = useState<any>(null);

  function confirmDelete(id: any) {
    setFileId(id)
    showConfirmationBox();
  }
  function showConfirmationBox() {
    setShowConfirmation(!showConfirmation);
  }
  function removeFile() {
    const newFiles = fileId && uploadedFiles.filter(file => file.fileId !== fileId);
    setUploadedFiles(newFiles);
    showConfirmationBox();
  }

  const downloadFile = async (url: string, token: string, fileName: string) => {

    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      const { status } = await MediaLibrary.requestPermissionsAsync();
      if (status !== 'granted') {
        alert('Sorry, we need media library permissions to make this work!');
      }
    }

    const uri = url;
    setFileType(uri.split('.').pop().toLowerCase());
    setDocType(uri.split('.').pop().toLowerCase());
    const fileUri = FileSystem.documentDirectory + fileName;
    let options = {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    };
    console.info('Trying to download ' + uri);
    console.info('Download Loc ' + fileUri);
    FileSystem.makeDirectoryAsync(FileSystem.documentDirectory, { intermediates: true })
      .then(() => {
        FileSystem.downloadAsync(uri, fileUri, options)
          .then(({ uri }) => {
            console.log('Finished downloading to ', uri);
            setDownloadedFileUri(uri);
            showModal();
            setFileLoad(false);
          })
          .catch(error => {
            console.error(error);
          });
      })
      .catch(error => {
        console.error('Error creating directory:', error);
      });
  }
  const openFile = async (fileId: string, fileName: string) => {
    const api = fileApi + encodeURIComponent(fileId);
    const accessToken = await getAccessToken();

    if (Platform.OS === "web") {
      setViewerFileName(fileName);
      setIsViewerVisible(true);
      setViewerLoading(true);
      setViewerBlob(null);
      try {
        const response = await fetch(api, {
          headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        if (!response.ok) {
          throw new Error(`Failed to fetch file: ${response.statusText}`);
        }
        const blob = await response.blob();
        setViewerBlob(blob);
      } catch (err) {
        console.error('Error opening file: ', err);
        setToastText("Failed to load file for preview.");
        setToastType('error');
        setToastVisibility(true);
        setIsViewerVisible(false);
      } finally {
        setViewerLoading(false);
      }
    } else {
      setFileLoad(true);
      downloadFile(api, accessToken, fileName);
    }
  }
  function getMiddleEllipsis(name: string, startChars = 12, endChars = 16) {
    if (!name) return "";

    // If already short enough, return as-is
    if (name.length <= startChars + endChars + 3) return name;

    const start = name.slice(0, startChars);
    const end = name.slice(-endChars);
    return `${start}…${end}`;
  }
  const fieldStyle = formMode === "View" ? formCustomStyles.fieldContianerViewMode : formCustomStyles.fieldContianer
  return (
    loadForm === false ? null :
      <View style={{ flex: 1 }}>
        <Portal>
          <NotificationBanner
            visible={toastVisibility}
            message={toastText}
            type={toastType}
            onDismiss={handleToastDismiss}
            duration={3000}
          />
        </Portal>
        <ScrollView>
            <>
              {/* <View style={[{ flex: 1, margin: 10 }, styles.buttonsContainer]}>
              {
                formMode === "View"
                  ?
                  <View>
                    <View style={[{ flex: 1 }, styles.buttonsContainer]}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' /></View>
                  </View>
                  :
                  <ScrollView horizontal>
                    <View style={styles.buttonsContainer}>
                      <View style={{}}>
                        <ButtonControl icon="content-save-edit" mode="contained" onPress={handleSubmit(onSubmit)} Title='Submit' />
                      </View>
                      <View style={{}}>
                        <ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' />
                      </View>
                    </View>
                  </ScrollView>
              }
             </View> */}



              {/* <View style={formCustomStyles.allFieldsContainer}> */}
              <View style={{}}>
                {fields && fields.map((field, index) => {
                  if (field.hidden === true) {
                    return null
                  }
                  else {
                    switch (field.subType) {
                      case 'text':
                        return (
                          // <Text>{field.key}</Text>
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <TextField
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              //editable={false}
                              field={field}
                              control={control}
                              styles={styles.input}
                              Ctrl={Controller}
                              errors={errors}
                              isDisabled={field.key === "Year" && formMode !== 'New' ? true : false}
                            />
                          </View>
                        );
                      case 'choice':
                        return (
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <ReactDropdownSingleSelect
                              field={field}
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              control={control}
                              Ctrl={Controller}
                              errors={errors}
                              isDisabled={(field.key === "Status" || field.key === "Month") && formMode !== 'New' ? true : false}
                            />
                          </View>
                        );
                      case 'float':
                        return (
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <NumberField
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              field={field}
                              control={control}
                              styles={styles.input}
                              Ctrl={Controller}
                              errors={errors}
                              logTitle={props.logTitle}
                              fields={fields}
                              setFields={setFields}
                              invalidNumber={invalidNumber}
                            //ref={register}
                            /></View>
                        );
                      case 'integer':
                        return (
                          <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle]}>
                            <NumberField
                              key={field.key.toString()}
                              editable={formMode === 'View' ? false : true}
                              field={field}
                              control={control}
                              styles={styles.input}
                              Ctrl={Controller}
                              errors={errors}
                              logTitle={props.logTitle}
                              fields={fields}
                              setFields={setFields}
                              invalidNumber={invalidNumber}
                            //ref={register}
                            /></View>
                        );
                      case 'date':
                        return (
                          (permissions.includes('admin') || permissions.includes('manage')) ?
                            <View key={index} nativeID={`field-${field.key}`} style={[fieldStyle, { zIndex: 1 }]}>
                              <PaperDates
                                key={field.key.toString()}
                                field={field}
                                editable={formMode === 'View' ? false : true}
                                control={control}
                                styles={styles.date}
                                Ctrl={Controller}
                                errors={errors}
                              //ref={register}
                              />
                            </View>
                            : null
                        );
                      default:
                        return null
                    }
                  }
                }
                )}
                {/* Attachment Section Start */}
                {docWarning === true && (
                  <View>
                    <Text style={{ color: 'red' }}>{warningText}</Text>
                  </View>
                )}

                <View style={{ paddingLeft: 10 }}>
                  <View style={{ flexDirection: 'column' }}>
                    {formMode !== "View" && (
                      <View style={{ padding: 20 }}>
                        <DocPicker 
                          formMode={formMode} 
                          onFileUploaded={onFileUploaded} 
                          clientAPIURL={clientAPIURL} 
                          showWarning={setDocWarning} 
                          warningText={setWarningText} 
                        />
                      </View>
                    )}
                    {docWarning === true && (
                      <View>
                        <Text style={{ color: 'red' }}>{warningText}</Text>
                      </View>
                    )}
                  </View>

                  <View style={{ paddingLeft: 20 }}>
                    {uploadedFiles.map((file: { fileId: string, fileName: string }, index) => (
                      <View key={index} style={{ flexDirection: "row", alignItems: "center", height: 50, gap: 8 }}>
                        <TouchableOpacity 
                          onPress={() => openFile(file.fileId, file.fileName)} 
                          style={{ flex: 1, minWidth: 0 }}
                          disabled={formMode === "New"}
                        >
                          <Text style={{ marginRight: 10 }}>
                            {index + 1}: <Text style={{ color: formMode === "New" ? '#333' : 'blue', textDecorationLine: formMode === "New" ? 'none' : 'underline' }} numberOfLines={1}>
                              {getMiddleEllipsis(file.fileName, 14, 18)}
                            </Text>
                          </Text>
                        </TouchableOpacity>
                        
                        {formMode !== "View" && (
                          <View style={{ flexShrink: 0 }}>
                            <Tooltip title="Remove attachment">
                              <IconButton
                                icon="close-circle-outline"
                                iconColor={MD3Colors.error50}
                                size={20}
                                onPress={() => confirmDelete(file.fileId)}
                              />
                            </Tooltip>
                          </View>
                        )}
                      </View>
                    ))}

                    {showConfirmation && (
                      <ConfirmTop
                        visible={showConfirmation}
                        title="Delete Attachment"
                        message="Are you sure you want to permanently delete this attachment? This action cannot be undone."
                        onYes={removeFile}
                        onNo={showConfirmationBox}
                        yesText="Delete"
                        noText="Cancel"
                      />
                    )}
                  </View>
                </View>
              </View>
                {/* Attachment Section End */}

              {/* Mirroring Section Start */}
              {(permissions.includes('admin') || permissions.includes('manage')) && (
                <View style={{ flexDirection: 'row', alignItems: 'center', padding: 15, backgroundColor: '#f9f9f9', margin: 10, borderRadius: 8, borderLeftWidth: 4, borderLeftColor: '#2196F3' }}>
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}>Mirror across Portfolio / Masterplan</Text>
                    <Text style={{ fontSize: 12, color: '#666' }}>Apply this status & freeze date to all packages in this masterplan.</Text>
                  </View>
                  <Switch
                    value={mirrorAcrossPortfolio}
                    onValueChange={() => setMirrorAcrossPortfolio(!mirrorAcrossPortfolio)}
                    color="#2196F3"
                  />
                </View>
              )}


              <View style={{ margin: 10 }}>
                {
                  formMode === "View"
                    ?
                    <View style={{}}><ButtonControl icon="lock-open-check" mode="contained" onPress={handleReOpen} Title='Re-Open' /></View>
                    :
                    permissions.includes('admin') || permissions.includes('manage') ?
                      <ScrollView horizontal style={{ width: '100%' }}>
                        <View style={styles.buttonsContainer}>
                          <View style={{}}><ButtonControl icon="lock-open-check" mode="contained" onPress={() => { formMode === 'New' ? (mirrorAcrossPortfolio ? setShowMirrorConfirmation(true) : handleSubmit(onSubmit, onError)()) : handleReOpen() }} Title={formMode === 'New' ? 'Save' : 'Re-Open'} disabled={isSubmitting} /></View>
                          {formMode === 'Edit' && <View style={{}}><ButtonControl icon="check-outline" mode="contained" onPress={() => { handleReview() }} Title={'Mark as Reviewed'} disabled={isSubmitting} /></View>}
                          <View style={{}}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' style={{ backgroundColor: '#676767' }} disabled={isSubmitting} /></View>
                        </View>
                      </ScrollView>
                      : permissions.includes('write') || permissions.includes('manage') ?
                        <ScrollView horizontal style={{ width: '100%' }}>
                          <View style={styles.buttonsContainer}>
                            <View style={{}}><ButtonControl icon="send-lock" mode="contained" onPress={() => { handleReSubmit() }} Title='Re-Submit' disabled={isSubmitting} /></View>
                            <View style={{}}><ButtonControl icon="close-circle-outline" mode="contained" onPress={handleClose} Title='Close' style={{ backgroundColor: '#676767' }} disabled={isSubmitting} /></View>
                          </View>
                        </ScrollView>
                        : null


                }
                {(formMode !== "View" && (permissions.includes('admin') || permissions.includes('manage'))) ?
                  <ScrollView horizontal style={{ width: '100%' }}>
                    <View style={styles.buttonsContainer}>
                      <View style={{}}><ButtonControl icon="send-lock" mode="contained" onPress={() => { handleReSubmit() }} Title='Re-Submit' disabled={isSubmitting} /></View>
                    </View>
                  </ScrollView>
                  : null
                }

                {/* <Input placeholder={''} value={d} /> */}
                <ComplianceTable logTitle={props.logTitle} siteId={props.siteId} />
              </View>
              <View>
                {/* Mirroring Section End */}
                <ConfirmBottom
                  visible={showMirrorConfirmation}
                  title="Bulk Update Confirmation"
                  message="Are you sure you want to update this status and freeze date across ALL packages in this Masterplan? This will send notifications to relevant stakeholders."
                  onYes={onConfirmMirror}
                  onNo={() => setShowMirrorConfirmation(false)}
                />
                {isSubmitting && (
                  <View style={{ alignItems: 'center', marginVertical: 20 }}>
                    <Loader size="large" />
                    <Text style={{ marginTop: 10, color: '#4BB75F', fontWeight: 'bold' }}>Processing your request... Please wait.</Text>
                  </View>
                )}
              </View>
            </>
          </ScrollView>
        <AttachmentViewerModal
          visible={isViewerVisible}
          onClose={() => setIsViewerVisible(false)}
          fileName={viewerFileName}
          blob={viewerBlob}
          loading={viewerLoading}
        />
      </View>
  );
});

const styles = StyleSheet.create({
  container: {
    //justifyContent: 'center',
    //alignItems: 'center',
    paddingLeft: '5%',
    paddingRight: '5%',

    flex: 1,
    padding: 16,
    gap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  formContainerPC: {
    paddingLeft: '25%',
    paddingRight: '25%',
  },
  formContainerMobile: {
    borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    backgroundColor: '#FFFFFF',
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4,
    //marginLeft: '5%',
    //marginRight: '5%',
    //paddingLeft: '2%',
    //paddingRight: '2%',
  },
  input: {
    backgroundColor: 'transparent',
    marginVertical: 5,
    marginBottom: 30,
    borderWidth: 1,
    //borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4,
    minHeight: 60,
    //maxHeight: 60,
  },
  date: {
    minWidth: '100%',
    minHeight: 60,
    maxHeight: 60,

    backgroundColor: 'transparent',
    marginVertical: 5,
    marginBottom: 30,
    borderWidth: 1,
    //borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)
    shadowColor: 'blue', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4
  },
  buttonsContainer: {
    flex: 1,
    //padding: 16,
    gap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    //alignItems: 'center',
    //justifyContent: 'space-evenly',
    height: 60
  }
});

export default ProjectStatusForm;


